import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.llm.taxonomy');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-llm-taxonomy',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.llm.taxonomy/view.scss */
:host {
  display: block;
  min-height: 100vh;
  color: #202733;
  background: #f3f5f8;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
}

.tech-doc-shell {
  min-height: 100vh;
}

.doc-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d9dee7;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}

.doc-topbar__inner {
  width: min(1240px, 100% - 32px);
  min-height: 58px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.doc-brand {
  color: #147a3b;
  font-size: 18px;
  font-weight: 850;
  letter-spacing: 0;
  text-decoration: none;
}

.doc-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.doc-nav a {
  padding: 7px 10px;
  border-radius: 6px;
  color: #475467;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.doc-nav a:hover,
.doc-nav a:focus-visible {
  color: #166534;
  background: #e8f5ed;
  outline: none;
}

.doc-page {
  width: min(1240px, 100% - 32px);
  margin: 0 auto;
  padding: 22px 0 42px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.doc-toc,
.doc-infobox,
.doc-article {
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.doc-toc,
.doc-infobox {
  position: sticky;
  top: 80px;
  padding: 14px;
}

.doc-toc h2,
.doc-infobox h2 {
  margin: 0;
  color: #101828;
  font-size: 15px;
  letter-spacing: 0;
}

.doc-toc ol {
  margin: 10px 0 0;
  padding-left: 0;
  list-style: none;
  display: grid;
  gap: 7px;
}

.doc-toc a {
  color: #475467;
  font-size: 12px;
  line-height: 1.45;
  text-decoration: none;
}

.doc-toc a:hover,
.doc-toc a:focus-visible {
  color: #147a3b;
  text-decoration: underline;
  outline: none;
}

.doc-title {
  padding: 28px 30px 22px;
  border-bottom: 1px solid #e4e8ef;
}

.doc-breadcrumb {
  margin: 0 0 8px;
  color: #147a3b;
  font-size: 12px;
  font-weight: 800;
}

.doc-title h1 {
  margin: 0;
  color: #111827;
  font-size: 36px;
  line-height: 1.2;
  letter-spacing: 0;
}

.doc-summary {
  max-width: 780px;
  margin: 14px 0 0;
  color: #475467;
  font-size: 15px;
  line-height: 1.75;
}

.doc-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 16px;
}

.doc-badges span {
  min-width: 0;
  padding: 5px 8px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #344054;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.ref {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  margin: 0 2px;
  padding: 0 3px;
  color: #166534;
  border-radius: 999px;
  cursor: help;
  font-size: 0.82em;
  font-weight: 800;
  line-height: 1.2;
  vertical-align: middle;
}

.ref:focus-visible {
  outline: 2px solid #86efac;
  outline-offset: 2px;
}

.ref::after {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  z-index: 20;
  width: max-content;
  max-width: min(320px, 72vw);
  padding: 8px 10px;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
  color: #14532d;
  content: attr(data-note);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  opacity: 0;
  pointer-events: none;
  text-align: center;
  transform: translate(-50%, 4px);
  transition: opacity 0.16s ease, transform 0.16s ease;
  white-space: normal;
}

.ref:hover,
.ref:focus-visible {
  background: #ffffff;
}

.ref:hover::after,
.ref:focus-visible::after {
  opacity: 1;
  transform: translate(-50%, 0);
}

.wiki-section {
  padding: 24px 30px;
  border-bottom: 1px solid #e4e8ef;
}

.wiki-section:last-child {
  border-bottom: 0;
}

.wiki-section h2 {
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9dee7;
  color: #111827;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: 0;
}

.wiki-section h3 {
  margin: 0 0 10px;
  color: #172033;
  font-size: 17px;
  line-height: 1.35;
  letter-spacing: 0;
}

.section-number {
  margin-right: 8px;
  color: #147a3b;
  font-weight: 850;
}

.wiki-section p {
  margin: 0 0 12px;
  color: #344054;
  font-size: 14px;
  line-height: 1.8;
}

.note-box,
.route-card {
  margin: 16px 0 4px;
  padding: 14px 16px;
  border: 1px solid #bfd8ca;
  border-left: 4px solid #16a34a;
  border-radius: 8px;
  background: #f1fbf5;
}

.note-box strong,
.route-card strong {
  display: block;
  margin-bottom: 5px;
  color: #14532d;
  font-size: 13px;
}

.route-card span {
  display: block;
  margin-bottom: 4px;
  color: #147a3b;
  font-size: 12px;
  font-weight: 850;
}

.doc-table {
  width: 100%;
  margin: 16px 0 6px;
  border-collapse: collapse;
  border: 1px solid #d9dee7;
  font-size: 13px;
}

.doc-table th,
.doc-table td {
  padding: 11px 12px;
  border: 1px solid #d9dee7;
  vertical-align: top;
  text-align: left;
}

.doc-table th {
  color: #172033;
  background: #f1f5f9;
  font-weight: 850;
}

.doc-table td {
  color: #344054;
  line-height: 1.65;
}

.visual-grid,
.figure-row,
.comparison-grid,
.split-list {
  display: grid;
  gap: 12px;
  margin: 16px 0;
}

.visual-grid,
.figure-row {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.comparison-grid,
.split-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.visual-card {
  min-width: 0;
  margin: 0;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}

.visual-card--wide {
  grid-column: 1/-1;
}

.inline-visual {
  margin: 18px 0;
}

.visual-card img {
  width: 100%;
  height: auto;
  display: block;
  background: #ffffff;
}

.visual-card figcaption {
  padding: 11px 12px 12px;
  color: #344054;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.55;
}

.compare-card,
.split-list > div {
  min-width: 0;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  padding: 16px;
  background: #fbfcfe;
}

.compare-card.is-strong {
  border-color: #b9d8c4;
  background: #f4fbf6;
}

.split-list ul,
.check-list,
.demo-list {
  margin: 8px 0 0;
  padding-left: 18px;
  color: #344054;
  font-size: 14px;
  line-height: 1.75;
}

.demo-list {
  margin-top: 14px;
}

.code-block {
  margin: 16px 0 0;
  padding: 14px 16px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  color: #d1fae5;
  background: #111827;
  overflow-x: auto;
  font-size: 13px;
  line-height: 1.7;
}

.code-block code {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
  white-space: pre-wrap;
}

.reference-list {
  margin: 10px 0 0;
  padding-left: 20px;
  color: #344054;
  font-size: 14px;
  line-height: 1.75;
}

.reference-list a {
  color: #147a3b;
  font-weight: 800;
  text-decoration: none;
}

.reference-marker {
  margin-right: 6px;
  color: #166534;
  font-weight: 850;
}

.reference-list a:hover,
.reference-list a:focus-visible {
  text-decoration: underline;
  outline: none;
}

.doc-infobox dl {
  display: grid;
  gap: 0;
  margin: 12px 0 0;
}

.doc-infobox dl div {
  padding: 10px 0;
  border-bottom: 1px solid #eef1f5;
}

.doc-infobox dt,
.doc-infobox dd {
  margin: 0;
  line-height: 1.45;
}

.doc-infobox dt {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.doc-infobox dd {
  margin-top: 3px;
  color: #172033;
  font-size: 13px;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.infobox-link {
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  border-radius: 6px;
  color: #ffffff;
  background: #147a3b;
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}

.infobox-link + .infobox-link {
  color: #147a3b;
  background: #e8f5ed;
}

.infobox-link:hover,
.infobox-link:focus-visible {
  background: #166534;
  color: #ffffff;
  outline: none;
}

@media (max-width: 1120px) {
  .doc-page {
    grid-template-columns: 1fr;
  }
  .doc-toc {
    position: static;
  }
}
@media (max-width: 820px) {
  .doc-topbar__inner,
  .doc-page {
    width: min(100% - 24px, 1240px);
  }
  .doc-topbar__inner {
    min-height: 64px;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    padding: 10px 0;
  }
  .doc-page,
  .visual-grid,
  .figure-row,
  .comparison-grid,
  .split-list {
    grid-template-columns: 1fr;
  }
  .doc-title,
  .wiki-section {
    padding: 22px 18px;
  }
  .doc-title h1 {
    font-size: 30px;
  }
}
.taxonomy-grid,
.decision-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin: 16px 0;
}

.taxonomy-card,
.decision-card {
  min-width: 0;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  padding: 15px 16px;
  background: #fbfcfe;
}

.taxonomy-card h3,
.decision-card h3 {
  display: block;
  margin: 0 0 8px;
  color: #172033;
  font-size: 15px;
  line-height: 1.35;
}

.taxonomy-card p,
.decision-card p {
  margin: 0;
  color: #475467;
  font-size: 13px;
  line-height: 1.65;
}

.taxonomy-card span {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  margin-bottom: 10px;
  border: 1px solid #b7d5c2;
  border-radius: 6px;
  padding: 3px 7px;
  color: #166534;
  background: #f4fbf6;
  font-size: 11px;
  font-weight: 850;
}

.taxonomy-card ul {
  margin: 10px 0 0;
  padding-left: 18px;
  color: #475467;
  font-size: 12px;
  line-height: 1.65;
}

.source-note {
  margin: 16px 0 0;
  border: 1px solid #bfd8ca;
  border-left: 4px solid #16a34a;
  border-radius: 8px;
  padding: 13px 15px;
  background: #f1fbf5;
}

.source-note strong {
  display: block;
  margin-bottom: 5px;
  color: #14532d;
  font-size: 13px;
}

.source-note p {
  margin: 0;
  color: #2f4f3a;
  font-size: 13px;
}

@media (max-width: 820px) {
  .taxonomy-grid,
  .decision-grid {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageLlmTaxonomyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public scrollToSection(event: MouseEvent, sectionId: string) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();

        const target = document.getElementById(sectionId);

        if (!target) {
            return;
        }

        const topbar = document.querySelector('.doc-topbar') as HTMLElement | null;
        const topbarHeight = topbar ? topbar.getBoundingClientRect().height : 0;
        const targetTop = window.scrollY + target.getBoundingClientRect().top - topbarHeight - 16;

        window.scrollTo({
            top: Math.max(0, Math.round(targetTop)),
            behavior: 'smooth',
        });
    }
}

export default PageLlmTaxonomyComponent;